import { FC, HTMLAttributes } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";
import clsx from "clsx";
import { Menu } from "@mantine/core";

import { IHeaderMenuItem } from "./DesktopHeader";
import { IHoverMenuState } from "./MegaMenuDropdown";

import MenuDownloadSection from "@/sections/common/MenuDownloadSection";

// ------------------------------------------------------------------------------------------

export type IMenuDropdownProps = HTMLAttributes<HTMLDivElement> &
  IHoverMenuState & {
    data: IHeaderMenuItem | undefined;
  };

const MenuDropdown: FC<IMenuDropdownProps> = (props) => {
  const { data, hoverMenu, setHoverMenu, className, ...other } = props;

  const path = usePathname();

  return (
    <>
      {data && (
        <div
          className={clsx(
            "flex h-full min-h-[60px] items-center justify-between border-b-[3px] border-solid border-transparent text-black-900 hover:border-blue-800",

            // if menu item is hovered or dropdown is hovered then show bottom border
            hoverMenu === data.label && "!border-blue-800",

            // if active page related to current menu then show border bottom
            data.options?.borderActive?.(data, path),
            className,
          )}
          onMouseEnter={() => setHoverMenu(data.label)}
          onMouseLeave={() => setHoverMenu("")}
          {...other}
        >
          <Menu
            classNames={{ dropdown: "border-0 p-0", item: "py-1.5" }}
            closeOnItemClick={true}
            trigger="click"
            offset={0}
            withinPortal={false}
            // Match MegaMenuDropdown z-index so regular dropdowns and the
            // mega menu stack at the same layer when they overlap.
            zIndex={999}
            opened={hoverMenu === data.label}
            onClose={() => setHoverMenu("")}
            styles={{
              item: { marginTop: "6px", marginBottom: "6px" },
            }}
          >
            <Menu.Target>
              {/* Trigger span fills the full row — padding here makes
                  the hover/click area wider, and Mantine positions the
                  dropdown relative to this span's bounding box. */}
              <span className="flex h-full cursor-pointer items-center px-4 font-bricolage-grotesque text-base font-normal">
                {data.label}
              </span>
            </Menu.Target>

            {data.items && data.items.length > 0 && (
              <Menu.Dropdown
                className={clsx(
                  "!top-[60px] !z-[999] rounded-t-none shadow-xl",

                  // Code for mega menu
                  //   data.items.some((item) => item.items) &&
                  //     "flex !max-h-[80vh] !w-screen justify-center overflow-y-auto shadow-lg",
                )}
              >
                <div
                  // Code for mega menu
                  //   className={clsx(
                  //     data.items.some((item) => item.items) &&
                  //       "container flex flex-row flex-wrap justify-start *:w-1/4 *:pb-5",
                  //   )}
                  className="flex"
                >
                  {/* // Code for mega menu Structure */}
                  {/* {data.items
                    .filter(
                      (item) =>
                        item.items !== undefined && item.items.length > 0,
                    )
                    .map((item, index) => (
                      <div key={index} className="flex flex-col">
                        <Menu.Item
                          component={Link}
                          href={item.href}
                          key={index}
                          className="mt-4 w-full bg-white"
                        >
                          <span className="border-b-2 border-b-transparent font-semibold text-primary-900 hover:border-primary-900">
                            {item.label}
                          </span>
                        </Menu.Item>

                        {item.items?.slice(0, 5).map((itm, i) => (
                          <Menu.Item
                            component={Link}
                            href={itm.href}
                            key={i}
                            className="w-full bg-white py-1 hover:text-secondary-900"
                          >
                            <span>{itm.label}</span>
                          </Menu.Item>
                        ))}

                        {item.items && item.items.length > 5 && (
                          <Menu.Item
                            href={item.href}
                            component={Link}
                            className="w-full bg-white"
                          >
                            <span className="border-b-2 border-b-transparent text-sm font-normal text-primary-900 hover:border-gray-500">
                              See All
                            </span>
                          </Menu.Item>
                        )}
                      </div>
                    ))} */}

                  <div
                    className={clsx(
                      "my-6 flex max-h-[81vh] flex-col gap-y-3 overflow-y-auto px-6",
                      data.downloadBook &&
                        "w-[50%] max-w-[1280px] border-r border-yellow-400",
                    )}
                  >
                    {data.items
                      .filter((item) => !item.items || item.items.length === 0)
                      .map((item, index) => {
                        return (
                          (item?.header === undefined || item?.header) && (
                            <Menu.Item
                              key={index}
                              href={item.href ?? ""}
                              component={Link}
                              className="w-fit max-w-[360px] bg-white font-bricolage-grotesque text-base font-normal hover:text-secondary-900"
                            >
                              {item.label}
                            </Menu.Item>
                          )
                        );
                      })}
                  </div>
                  {/* Download Now Section */}
                  {data.downloadBook && (
                    <MenuDownloadSection
                      className="xl:p-10"
                      heading={data.downloadBook.heading}
                      image={data.downloadBook.image}
                      button={data.downloadBook.button}
                    />
                  )}
                </div>
              </Menu.Dropdown>
            )}
          </Menu>
        </div>
      )}
    </>
  );
};

export default MenuDropdown;
